import { isWeb } from "@tamagui/core";
import { colors } from "../config/colors.mjs";
const sizeTokens = {
    "button.danger": isWeb ? 40 : 48,
    "button.discreet": isWeb ? 32 : 40,
    "button.primary": isWeb ? 40 : 48,
    "button.secondary": isWeb ? 40 : 48,
    "button.tertiaryIndicator.height": 1.5
  },
  spaceTokens = {
    "button.bottomPadding.danger": 0,
    "button.bottomPadding.discreet": 0,
    "button.bottomPadding.primary": 0,
    "button.bottomPadding.secondary": 0,
    "button.bottomPadding.tertiary": 2,
    "button.gap.danger": 12,
    "button.gap.discreet": 8,
    "button.gap.primary": 12,
    "button.gap.secondary": 12,
    "button.gap.tertiary": 8,
    "button.horizontalPadding.danger": 20,
    "button.horizontalPadding.danger.hugContentWithIcon": 16,
    "button.horizontalPadding.discreet": 16,
    "button.horizontalPadding.discreet.hugContentWithIcon": 12,
    "button.horizontalPadding.primary": 20,
    "button.horizontalPadding.primary.hugContentWithIcon": 16,
    "button.horizontalPadding.secondary": 20,
    "button.horizontalPadding.secondary.hugContentWithIcon": 16,
    "button.horizontalPadding.tertiary": 0,
    "button.horizontalPadding.tertiary.hugContentWithIcon": 0
  },
  radiusTokens = {
    "button.default": 50
  },
  colorTokens = {
    "button.danger.background": colors["grey.200"],
    "button.danger.background.disabled": colors["grey.200"],
    "button.danger.background.hover": colors["grey.300"],
    "button.danger.background.press": colors["grey.300"],
    "button.danger.text": colors["red.600"],
    "button.danger.text.disabled": colors["red.500"],
    "button.danger.text.hover": colors["red.600"],
    "button.danger.text.press": colors["red.600"],
    "button.discreet.background": colors["grey.200"],
    "button.discreet.background.disabled": colors["grey.200"],
    "button.discreet.background.hover": colors["grey.300"],
    "button.discreet.background.press": colors["grey.300"],
    "button.discreet.text": colors["grey.700"],
    "button.discreet.text.disabled": colors["grey.500"],
    "button.discreet.text.hover": colors["grey.700"],
    "button.discreet.text.press": colors["grey.700"],
    "button.primary.background": colors["grey.800"],
    "button.primary.background.disabled": colors["grey.200"],
    "button.primary.background.hover": colors["grey.700"],
    "button.primary.background.press": colors["grey.700"],
    "button.primary.text": colors.white,
    "button.primary.text.disabled": colors["grey.500"],
    "button.primary.text.hover": colors.white,
    "button.primary.text.press": colors.white,
    "button.secondary.background": colors["grey.200"],
    "button.secondary.background.disabled": colors["grey.200"],
    "button.secondary.background.hover": colors["grey.300"],
    "button.secondary.background.press": colors["grey.300"],
    "button.secondary.text": colors["grey.800"],
    "button.secondary.text.disabled": colors["grey.500"],
    "button.secondary.text.hover": colors["grey.800"],
    "button.secondary.text.press": colors["grey.800"],
    "button.tertiary.background": "transparent",
    "button.tertiary.background.disabled": "transparent",
    "button.tertiary.background.hover": "transparent",
    "button.tertiary.background.press": "transparent",
    "button.tertiary.text": colors["grey.800"],
    "button.tertiary.text.disabled": colors["grey.500"],
    "button.tertiary.text.hover": colors["grey.700"],
    "button.tertiary.text.press": colors["grey.700"]
  };
export { colorTokens, radiusTokens, sizeTokens, spaceTokens };